import { TimeframeTypeEnum } from "../../../common/enums/TimeframeTypeEnum";
import { IPolledDevicesGridCell, IPolledDevicesGridRow } from "../../../services/summary-listing-data-service/DeviceSummaryModels";
import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import * as DRCX from "../../../common/enums/DRCXEnums";
import { getTimeframeTimeDisplayText } from "../../../common/utilities/TimeframeUtilities";
import { IWellSummaryGridRow, IWellSummaryGridCell } from "../../../services/summary-listing-data-service/WellSummaryModels";
import { UIViewEnum } from "../../../common/enums/UIViewEnum";
import { getDeviceRoute, getTagRoute, getWellRoute } from "../../../common/utilities/RouteHelpers";
import { IRowNode } from "ag-grid-enterprise";

export function dataValueCellStyler(params: any): any {
    const cell = params.colDef.cellRendererParams.cellDataGetter(params);
    const style: { [key: string]: string; } = {};

    if (cell?.objectType === eLynxObjectTypeEnum.Tag) {
        if (cell.timestamp) {
            style.whiteSpace = "nowrap";
        } else {
            if (cell.inAlarm || cell.inStaleDataAlarm) {
                style.fontWeight = "bold";
                if (cell.inAlarm) {
                    style.backgroundColor = cell.backgroundColor;
                }
                if (cell.inStaleDataAlarm) {
                    style.color = cell.staleDataColor;
                }
            }
        }

        return style;
    }
}

export function nameCellStyler(params: any): any {
    //const cell = params.colDef.cellRendererParams.cellDataGetter(params);
    const style: { [key: string]: string; } = {};

    if (!params?.data?.active) {
        style.fontStyle = "italic";
        return style;
    }
}

export function memoCellStyler(params: any): any {
    //const cell = params.colDef.cellRendererParams.cellDataGetter(params);
    const style: { [key: string]: string; } = {
        initialWidth: '200px'
    };

    return style;
}




export function getDisplayText(cell: IPolledDevicesGridCell): string {
    var text: string = (cell.displayText ? cell.displayText : "");

    if (cell.objectType === eLynxObjectTypeEnum.Tag && (typeof cell.timestamp === "string"|| typeof cell.timestamp === "object") && cell.timestamp) {
        text = getTimeframeTimeDisplayText(cell.displayTimeframe ?? TimeframeTypeEnum.None, cell.timestamp);
    }

    return text;
}

export function hasHRef(cell: IPolledDevicesGridCell): boolean {
    return ((cell.objectType === eLynxObjectTypeEnum.Tag && !cell.timestamp) ||
        cell.objectType === eLynxObjectTypeEnum.Device ||
        cell.objectType === eLynxObjectTypeEnum.Well) &&
        (!cell.isAttributeCell || (!!cell.optionalColumn &&
            _getOptionalColumnsIncludedForHREF().filter(oc => oc === cell.optionalColumn).length > 0));
}

export function _getOptionalColumnsIncludedForHREF(): Array<DRCX.OptionalColumnEnum> {
    return [
        DRCX.OptionalColumnEnum.DeviceName,
        DRCX.OptionalColumnEnum.DeviceDisplayName,
        DRCX.OptionalColumnEnum.WellName
    ];
}


export function postSortByOrder(rowNodes: Array<IRowNode>) {

    return rowNodes.sort((a, b) => (a.data?.order ?? 0) - (b.data?.order?? 0));
}

export function postSortDevicesOnAlarms(rowNodes: Array<IRowNode>) {
    function getAlarmStatus(rowNode: IRowNode): number {
        return rowNode.data?.alarmStatus;
    }

    postSortOnAlarms(rowNodes, getAlarmStatus);
}

export function postSortWellsOnAlarms(rowNodes: Array<IRowNode>) {
    function getAlarmStatus(rowNode: IRowNode): number {
        return rowNode.data?.alarmStatus;
    }

    postSortOnAlarms(rowNodes, getAlarmStatus);
}

export function postSortAlarmLynxOnAlarms(rowNodes: Array<IRowNode>) {
    function getAlarmStatus(rowNode: IRowNode): number {
        return rowNode.data?.cell2.dataValue;
    }

    postSortOnAlarms(rowNodes, getAlarmStatus);
}

export function postSortCompressorLynxOnAlarms(rowNodes: Array<IRowNode>) {
    function getAlarmStatus(rowNode: IRowNode): number {
        return rowNode.data?.cell3.dataValue;
    }

    postSortOnAlarms(rowNodes, getAlarmStatus);
}

function postSortOnAlarms(rowNodes: Array<IRowNode>, getAlarmStatus: (rowNode: IRowNode) => number) {
    function move(toIndex: number, fromIndex: number) {
        rowNodes.splice(toIndex, 0, rowNodes.splice(fromIndex, 1)[0]);
    }

    let nextAcknowledgedOnlyInsertPos = 0;
    let nextUnacknowledgedOnlyInsertPos = 0;
    let nextAckAndUnAckBothInsertPos = 0;

    for (let i = 0; i < rowNodes.length; i++) {
        const alarmStatus = getAlarmStatus(rowNodes[i]);

        // AcknowledgedOnly
        if (alarmStatus === 1) {
            move(nextAcknowledgedOnlyInsertPos, i);
            nextAcknowledgedOnlyInsertPos++;
        // UnacknowledgedOnly
        } else if (alarmStatus === 2) {
            move(nextUnacknowledgedOnlyInsertPos, i);
            nextAcknowledgedOnlyInsertPos++;
            nextUnacknowledgedOnlyInsertPos++;
        // AckAndUnAckBoth            
        } else if (alarmStatus === 3) {
            move(nextAckAndUnAckBothInsertPos, i);
            nextAcknowledgedOnlyInsertPos++;
            nextUnacknowledgedOnlyInsertPos++;
            nextAckAndUnAckBothInsertPos++;
        }
    }
}

// TODO: Change these to redirect once it's implemented
export function getRoute(row: IPolledDevicesGridRow | IWellSummaryGridRow, 
                cell: IPolledDevicesGridCell | IWellSummaryGridCell, 
                groupID?: number,
                deviceViewID?: UIViewEnum): string {

    var href: string = "";
    switch (cell.objectType) {
        case eLynxObjectTypeEnum.Tag:
            href = getTagRoute(UIViewEnum.Tag_Details, groupID, (row as IWellSummaryGridRow).wellID, (row as IPolledDevicesGridRow).deviceID, undefined, undefined, cell.objectID);
            break;
        case eLynxObjectTypeEnum.Device:
            href = getDeviceRoute(deviceViewID ?? UIViewEnum.Device_Details, groupID, undefined, cell.objectID);
            break;
        case eLynxObjectTypeEnum.Well:
            href = getWellRoute(UIViewEnum.Well_Details, groupID, cell.objectID);
            break;
    }
    return href;
}



